import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17b997a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { inject, ref, toRefs, watch } from 'vue';

import { SwiperSlide } from '@/support/interfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoWrapper',
  props: {
    src: null
  },
  setup(__props: any) {

const props = __props as { src: string }



const { src } = toRefs(props);

const videoPlayer = ref<any>(null);

const playOrPauseVideo = (shouldPlay: boolean) => {
  if (shouldPlay) {
    videoPlayer.value.focus();
    videoPlayer.value.play();
  } else {
    videoPlayer.value.pause();
  }
};

const swiper = inject<SwiperSlide>('swiperSlide', {
  isActive: false,
});

watch(swiper, (newValue) => playOrPauseVideo(newValue.isActive));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("video", {
    ref_key: "videoPlayer",
    ref: videoPlayer,
    src: _unref(src),
    loop: "",
    controls: "",
    muted: false
  }, null, 8, _hoisted_1))
}
}

})